import React from 'react';
import { cn } from '../lib/utils';
import type { LucideIcon } from 'lucide-react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string | React.ReactNode;
  icon?: LucideIcon;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  /** Custom classes for the icon container backdrop */
  iconContainerClassName?: string;
  /** Custom classes for the icon itself */
  iconClassName?: string;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  actions,
  children,
  iconContainerClassName,
  iconClassName,
  className,
}) => {
  return (
    <div
      className={cn('flex flex-col md:flex-row md:items-center justify-between gap-4', className)}
    >
      <div className="flex items-center gap-4">
        {Icon && (
          <div
            className={cn(
              'hidden sm:flex p-2.5 bg-primary/10 dark:bg-primary/20 rounded-xl items-center justify-center shrink-0 shadow-sm border border-primary/10',
              iconContainerClassName
            )}
          >
            <Icon className={cn('w-6 h-6 md:w-7 md:h-7 text-primary', iconClassName)} />
          </div>
        )}
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight">{title}</h1>
          {subtitle && (
            <p className="text-sm md:text-base text-muted-foreground font-medium">{subtitle}</p>
          )}
        </div>
      </div>
      {actions || children}
    </div>
  );
};
